// extracted by mini-css-extract-plugin
export default {"Label":"aggregate-labels-module__Label--RfRrb","default":"aggregate-labels-module__default--ZkfkM","danger":"aggregate-labels-module__danger--NPFSz"};